interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizeClasses = {
    sm: 'spinner--sm',
    md: '',
    lg: 'spinner--lg',
  };

  return (
    <div className={`spinner ${sizeClasses[size]} ${className}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingState({ size = 'md' }: LoadingStateProps) {
  const rows = size === 'sm' ? 2 : size === 'lg' ? 5 : 3;
  return (
    <div className="loading-state" role="status" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="skeleton skeleton--line"
          style={{ width: `${75 - i * 12}%`, height: size === 'lg' ? 18 : 14 }}
        />
      ))}
    </div>
  );
}

export default Spinner;
